import { render } from "./NelsonButton.vue?vue&type=template&id=b65eaf66&scoped=true"
import script from "./NelsonButton.vue?vue&type=script&lang=js"
export * from "./NelsonButton.vue?vue&type=script&lang=js"

import "./NelsonButton.vue?vue&type=style&index=0&id=b65eaf66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65eaf66"]])

export default __exports__